var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"button",class:[_setup.props.roundedSize, _setup.props.borderColor, _setup.props.textColor]},[_vm._v(" "+_vm._s(_setup.props.title ? _setup.props.title : "Button")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }